import { css } from '@emotion/css';
import { dropdownMenuClassName } from '@snapchat/snap-design-system-marketing';

export const localeDropdownCss = css`
  .sdsm-dropdown-button {
    font-size: 14px;
    line-height: 20px;
  }

  .${dropdownMenuClassName} {
    max-width: 200%;
  }
`;
